import { authFetch } from "@/lib/authFetch";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin`;
let jobs = [];
const listeners = new Set();
const emit = () => listeners.forEach((l) => l([...jobs]));
const patch = (id, p) => { jobs = jobs.map((j) => (j.id === id ? { ...j, ...p } : j)); emit(); };

export const subscribeJobs = (fn) => { listeners.add(fn); fn([...jobs]); return () => listeners.delete(fn); };
export const dismissJob = (id) => { jobs = jobs.filter((j) => j.id !== id); emit(); };

const poll = async (id) => {
  for (;;) {
    await new Promise((r) => setTimeout(r, 2000));
    try {
      const res = await authFetch(`${API}/link-jobs/${id}`, { credentials: "include" });
      if (!res.ok) continue;
      const job = await res.json();
      patch(id, { done: job.done, updated: job.updated, status: job.status, result: job.status === "done" ? job : null });
      if (job.status === "done") {
        window.dispatchEvent(new CustomEvent("link-job-done", { detail: job }));
        return;
      }
    } catch {
      /* keep polling */
    }
  }
};

export const startUndoJob = async (entryId, title) => {
  const res = await authFetch(`${API}/history/${entryId}/undo`, { method: "POST", credentials: "include" });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Could not undo");
  jobs = [...jobs, { id: data.job_id, title, kind: "undo", label: "", total: data.total, done: 0, updated: 0, status: "running", result: null }];
  emit();
  poll(data.job_id);
  return data.job_id;
};

// Start a background link change; returns the job id. Throws with the server message on rejection.
export const startLinkJob = async (items, kind, title, label = "") => {
  const res = await authFetch(`${API}/link-changes`, {
    method: "POST", credentials: "include", headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items, kind, label }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Could not start the change");
  jobs = [...jobs, { id: data.job_id, title, kind, label, total: data.total, done: 0, updated: 0, status: "running", result: null }];
  emit();
  poll(data.job_id);
  return data.job_id;
};
